import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'
import {getField, updateField} from "vuex-map-fields";

const state = {
    libraries: [],
    library: [],
    scriptTypes: [],
    languages: [],
    languageSelected: 'ita',
    translations: [],
    id: 0,
    scanID: null
}

const getters = {
    libraries: state => state.libraries,
    library: state => state.library,
    scriptTypes: state => state.scriptTypes,
    languages: state => state.languages,
    languageSelected: state => state.languageSelected,
    translations: state => state.translations,
    scanID: state => state.scanID,
}

const actions = {

    loadLibraries (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadLibraries', { libraries: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    loadLibrary (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadLibrary', { library: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    createLibrary (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('createLibrary', { library: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    async saveLibrary({ commit, dispatch }, credentials) {
        try {
            const data = await appService.connectToServer(credentials);
            console.log(data.message);
            if (data.success) {
                commit('saveLibrary', {
                    Library: data.Library,
                });
                dispatch('addMessage', data, { root: true });
                return data.Library;
            }
            dispatch('addMessage', data, { root: true });
        } catch (err) {
            dispatch('addMessage', err.toString(), { root: true });
        }
    },

    deleteLibrary (context, credentials) {
        appService.connectToServer(credentials).then(data => {

            if( data.success ) {
                context.commit('deleteLibrary', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }

        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    languageSelect(context, slug) {
        context.commit('languageSelect', slug)
    },

    resetLibrary (context) {
        state.library = [],
        state.languageSelected = 'ita',
        state.translations = []
    },

}

const mutations = {

    loadLibraries (state, data) {
        state.libraries = data.libraries.result
    },
    loadLibrary (state, data) {
        state.library = data.library.result
        state.scriptTypes = data.library.data.scriptType
        state.languages = data.library.data.languages
        state.translations = data.library.data.translations
    },
    createLibrary (state, data) {
        state.scriptTypes = data.library.data.scriptType
        state.languages = data.library.data.languages
        state.translations = data.library.data.translations
    },
    saveLibrary(state, { Library }) {
        state.library.requestLogCreate = Library.requestLogCreate;
        state.library.requestLogUpade = Library.requestLogUpade;
    },
    deleteLibrary (state, data) {
        let index = _.findIndex(state.libraries, function(o) { return o.id == data.id; });
        state.libraries.splice(index, 1)
    },
    languageSelect (state, slug) {
        state.languageSelected = slug.slug
    },
    setLibraryField(state, { field, value }) {
        state.library[field] = value;
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
